import { Tab, TabPane } from "semantic-ui-react";
import { CREATE_USER, LOGIN } from "../routes/mutations";
import { useNavigate } from "react-router-dom";
import { FormFieldComponentProps } from "../components/new_form/form_fields/FormFieldComponent";
import { NewPageComponent } from "../components/page/NewPageComponent";
import { NewNewFormComponentProps } from "../components/new_form/NewNewFormComponent";

const formFields: FormFieldComponentProps[] = [
  {
    type: "text",
    key: "email",
    label: "Email",
    required: true,
    placeholder: "Email Address",
  },
  {
    type: "password",
    key: "password",
    label: "Password",
    required: true,
    placeholder: "Password",
  },
];

export const LoginPage = () => {
  const navigate = useNavigate();

  const setSessionAndGoToApp = (data: any) => {
    localStorage.setItem("second-brain-session", data);
    navigate("/");
  };

  const temp = new NewNewFormComponentProps({
    form: {
      formFields: formFields,
      type: "single_form",
    },
    startingData: { email: "", password: "" },
  });

  const panes = [
    {
      menuItem: "Create Account",
      render: () => (
        <TabPane attached={false} id="create-user-tab">
          <NewPageComponent
            props={{
              type: "form",
              form: temp,
              button: {
                label: "Create Account",
                apiCall: CREATE_USER,
                callback: setSessionAndGoToApp,
              },
            }}
          />
        </TabPane>
      ),
    },
    {
      menuItem: "Login",
      render: () => (
        <TabPane attached={false} id="login-tab">
          <NewPageComponent
            props={{
              type: "form",
              form: temp,
              button: {
                label: "Login",
                apiCall: {
                  documentNode: LOGIN,
                  key: "login",
                },
                callback: setSessionAndGoToApp,
              },
            }}
          />
        </TabPane>
      ),
    },
  ];

  return <Tab menu={{ secondary: true, pointing: true }} panes={panes} />;
};
